"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONLINE_STATUS = exports.VISIBILITY = exports.STATUS = void 0;
var STATUS = {
  ACTIVE: 'Active',
  DISABLED: 'InActive'
};
exports.STATUS = STATUS;
var VISIBILITY = {
  ACTIVE: 'Shown',
  INACTIVE: 'Hidden'
};
exports.VISIBILITY = VISIBILITY;
var ONLINE_STATUS = {
  online: 'online',
  away: 'away',
  offline: 'offline',
  out: 'out'
};
exports.ONLINE_STATUS = ONLINE_STATUS;
//# sourceMappingURL=status.js.map